import { PayloadAction } from '@reduxjs/toolkit';

import { DataState } from 'editor/src/component/DesktopSidebar/TabContents/Plugins/ContentProviderPlugin/store/types';

const setRequestVersionReducer = (state: DataState, action: PayloadAction<number>) => {
  state.requestVersion = action.payload;
};

export default setRequestVersionReducer;
